import { Component, OnInit } from '@angular/core';
import { Observable } from "rxjs/Rx";
import { BackendResponse } from "app/model/backend-response.model";
import { CustomHttp } from "app/customhttp";
import { AuthenticationService } from "app/service/authentication.service";
import {Router} from '@angular/router';
import {AppComponent} from '../app.component';

@Component({
  selector: 'app-process-error',
  templateUrl: './process-error.component.html',
  styleUrls: ['./process-error.component.css']
})
export class ProcessErrorComponent implements OnInit {

  Response: BackendResponse;

  constructor(public http: CustomHttp,
              public authenticationService: AuthenticationService, private router: Router, private appComponent: AppComponent ) { }

  ngOnInit() {
    this.http.getErrorResponseSubject()
      .subscribe(
        (res: BackendResponse) => {
          if (res.message === 'Servis hatasi olustu: [Source object must not be null]') {
          }
          this.Response = res;
          this.appComponent.notificationOn('error' , res.message);
          this.router.navigate(['/']);
        }
    );
  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/process-error/process-error.component.ts